import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import Carga from "../../../componentes/cargando/Cargando.js";
import "../../../static/css/dashBoardDueno.css";

const DashBoardDueno = () => {
  const navigate = useNavigate();
  const { verificacionToken } = useAuth();
  const [cargando, setCargando] = useState(true);
  const [botonBloqueado, setBotonBloqueado] = useState(true);

  useEffect(() => {
    const verificar = async () => {
      await verificacionToken("ROLE_DUENO");
      setCargando(false);
    };
    verificar();
  }, []);

  if (cargando)
    return (
        <div className="loading-overlay">
          <Carga />
        </div>
    );

  return (
      <div className="container-fluid pb-5 pt-5">
        <div className="row">
          {/* Sidebar */}
          <div className="col-12 col-md-3 mb-4">
            <div className="sidebar btn-group-vertical w-100 shadow p-3 rounded">
              <Link to="/dueno/empleados" className="btn w-100 mb-2">
                Registro de Empleados
              </Link>
              <Link to="/dueno/administrador" className="btn w-100 mb-2">
                Registro de Administrador
              </Link>
              <Link to="/dueno/ventas-empleados" className="btn w-100 mb-2">
                Ver Ventas Diarias
              </Link>
              <Link
                  to="/dueno/ventasLocales"
                  className="btn w-100 mb-2"
                  tabIndex={botonBloqueado ? -1 : 0}
                  aria-disabled={botonBloqueado}
              >
                Ver Ventas Locales
              </Link>
              <Link to="/dueno/configuraciones" className="btn w-100 mb-2">
                Configuraciones
              </Link>
              <button
                  type="button"
                  className="btn w-100 btn-volver"
                  onClick={() => navigate("/dueno")}
              >
                Volver Principal
              </button>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="col-12 col-md-9">
            <div className="dashboard-content">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
  );
};

export default DashBoardDueno;

